import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    width: '100%',
    background: semanticColors.background.secondary,
    padding: '0 8px',
    position: 'relative',
  },
  layoutColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
    flex: '1 1 50%',
    gap: '16px',
    overflowY: 'auto',
  },
  fontSettingsBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '16px',
  },
  fontStyleSelect: {
    minWidth: '300px',
  },
  checkboxOption: {
    marginLeft: '0px',
  },
  sectionLabel: {
    fontWeight: foundations.typography.fontWeight.medium,
  },
});
